package com.wintermar.inspection

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String
import kotlin.collections.Collection
import migrations.AnswerSelectionTable

public class AnswerSelectionTableQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getAnswerSelectionByAnswerId(answerId: String, mapper: (
    id: String,
    answerId: String,
    answerSelectionId: String,
    answerSelectionValue: String,
  ) -> T): Query<T> = GetAnswerSelectionByAnswerIdQuery(answerId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!
    )
  }

  public fun getAnswerSelectionByAnswerId(answerId: String): Query<AnswerSelectionTable> = getAnswerSelectionByAnswerId(answerId, ::AnswerSelectionTable)

  /**
   * @return The number of rows updated.
   */
  public fun insertAnswerSelection(
    id: String,
    answerId: String,
    answerSelectionId: String,
    answerSelectionValue: String,
  ): QueryResult<Long> {
    val result = driver.execute(320_277_571, """
        |INSERT INTO AnswerSelectionTable(id, answerId, answerSelectionId, answerSelectionValue)
        |VALUES (?, ?, ?, ?)
        |ON CONFLICT(id) DO UPDATE SET
        |   answerId=excluded.answerId,
        |   answerSelectionId=excluded.answerSelectionId,
        |   answerSelectionValue=excluded.answerSelectionValue
        """.trimMargin(), 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, answerId)
          bindString(parameterIndex++, answerSelectionId)
          bindString(parameterIndex++, answerSelectionValue)
        }
    notifyQueries(320_277_571) { emit ->
      emit("AnswerSelectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertReplaceAnswerSelection(
    id: String,
    answerId: String,
    answerSelectionId: String,
    answerSelectionValue: String,
  ): QueryResult<Long> {
    val result = driver.execute(456_712_101, """
        |INSERT OR REPLACE INTO AnswerSelectionTable(id, answerId, answerSelectionId, answerSelectionValue)
        |VALUES (?, ?, ?, ?)
        """.trimMargin(), 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, answerId)
          bindString(parameterIndex++, answerSelectionId)
          bindString(parameterIndex++, answerSelectionValue)
        }
    notifyQueries(456_712_101) { emit ->
      emit("AnswerSelectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAnswerSelectionByAnswerId(answerId: String): QueryResult<Long> {
    val result = driver.execute(-821_609_247, """DELETE FROM AnswerSelectionTable WHERE answerId = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, answerId)
        }
    notifyQueries(-821_609_247) { emit ->
      emit("AnswerSelectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAnswerSelectionByAnswerIds(answerId: Collection<String>): QueryResult<Long> {
    val answerIdIndexes = createArguments(count = answerId.size)
    val result = driver.execute(null, """DELETE FROM AnswerSelectionTable WHERE answerId IN $answerIdIndexes""", answerId.size) {
          var parameterIndex = 0
          answerId.forEach { answerId_ ->
            bindString(parameterIndex++, answerId_)
          }
        }
    notifyQueries(299_917_234) { emit ->
      emit("AnswerSelectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAllAnswerSelection(): QueryResult<Long> {
    val result = driver.execute(-1_247_287_030, """DELETE FROM AnswerSelectionTable""", 0)
    notifyQueries(-1_247_287_030) { emit ->
      emit("AnswerSelectionTable")
    }
    return result
  }

  private inner class GetAnswerSelectionByAnswerIdQuery<out T : Any>(
    public val answerId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("AnswerSelectionTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("AnswerSelectionTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(2_096_786_874, """SELECT AnswerSelectionTable.id, AnswerSelectionTable.answerId, AnswerSelectionTable.answerSelectionId, AnswerSelectionTable.answerSelectionValue FROM AnswerSelectionTable WHERE answerId = ? ORDER BY answerSelectionId ASC""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, answerId)
    }

    override fun toString(): String = "AnswerSelectionTable.sq:getAnswerSelectionByAnswerId"
  }
}
